import React, { forwardRef, useEffect, useState } from "react";
import { TextField, Autocomplete, CircularProgress } from "@mui/material";
import { factory } from "../../api/apiFactory";

const jobTitleApi = factory.get("jobTitle");

export const SelectJobTitle = forwardRef((props, ref) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const fetchJobTitle = (search = "") => {
    setLoading(true);
    jobTitleApi.index({ skip: 0, take: 40, search: search }).then((res) => {
      setOptions(res.data.data);
      setLoading(false);
    });
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      fetchJobTitle(search);
    }, 500);
    return () => clearTimeout(timeout);
  }, [search]);

  return (
    <Autocomplete
      ref={ref}
      options={options}
      {...props}
      getOptionLabel={(option) => `${option.name_en} - ${option.name_ar}`}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => (
        <TextField
          {...params}
          label={!props.label ? "Job Title" : props.label}
          error={props.error ? props.error : null}
          helperText={props.helperText ? props.helperText : null}
          onChange={(e, value) => {
            setSearch(e.target.value);
          }}
          size="small"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
});
